import { Injector } from '@angular/core';
import { BaseContractFactory } from '../../currencies-factory/contract-factory-base';
import { EVMErc20ContractFactory } from '../../currencies-factory/evm-erc20-contract-factory.service';
import { NetworksService } from '../../networks/networks.service';
import { PricesService } from '../../prices/prices.service';
import { EVMProviderFactoryService } from '../../provider/evm-provider-factory.service';
import { EVMBlockChainExplorerFactoryService } from '../explorers/evm-blockchain-explorer.service';
import { ITransactionResponceEx } from '../explorers/types';
import { ICurrency } from '../base-currency';

export abstract class IParseService
{
    protected pricesService: PricesService;
    protected providerFactoryService: EVMProviderFactoryService;
    protected explorerService: EVMBlockChainExplorerFactoryService;
    protected contractFactory: EVMErc20ContractFactory;
    protected networkService: NetworksService;


    constructor(protected injector: Injector)
    {
        this.pricesService = this.injector.get(PricesService);
        this.providerFactoryService = this.injector.get(EVMProviderFactoryService);
        this.explorerService = this.injector.get(EVMBlockChainExplorerFactoryService);
        this.contractFactory = this.injector.get(EVMErc20ContractFactory);
        this.networkService = this.injector.get(NetworksService);
    }

    public abstract parseDataConfirmation(_tx: ITransactionResponceEx,_chainId: number, _currency: ICurrency): any;
    public abstract parseDataVisualization(_tx: ITransactionResponceEx, _currency: ICurrency, _parseData?: boolean): any;
    public abstract parseDataValueAndFee(_tx, _currency: ICurrency): Promise<any>;
    public abstract parseFeeData(_tx, _currency: ICurrency): Promise<any>;
    public abstract getContractByTxData(_tx: any,_chainId: number, _address: string);
}

export interface IParseFactory
{
    CreateParse(platform: string): IParseService
}